import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Multiselect from 'components/Multiselect';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { CustomDateRange } from 'components/date-range';
import { AcceptedDateRange } from 'components/accepted-date-range';
import { AppSettings } from '../../constants';
import { Panel } from 'react-bootstrap';
import Translate from 'components/translate';
import queryString from 'query-string';
import pickBy from 'lodash/pickBy';
const convertStringMultiParamsToSelectedOption = stringParams => {
  let selectedOption = [];
  if (stringParams) {
    const parsedParams = queryString.parse(stringParams);

    Object.keys(parsedParams).map(el => {
      selectedOption.push(queryString.parse(parsedParams[el]));
    });
  }
  return selectedOption;
};

const defaultStatusSelectList = AppSettings.RFS_STATUS_VALUE;

class BuilderPunchListFilter extends Component {
  static propTypes = {
    RegionSelectList: PropTypes.array,
    RequestTypeSelectList: PropTypes.array,
    onFetchRegion: PropTypes.func,
    MarketSelectList: PropTypes.array,
    onFetchMarket: PropTypes.func,
    ProjectSelectList: PropTypes.array,
    RFSManagedBySelectList: PropTypes.array,
    LotSelectList: PropTypes.array,
    onFetchProject: PropTypes.func,
    onSearchRFS: PropTypes.func,
    onFetchRFSManagedBy: PropTypes.func,
    onFetchRequestType: PropTypes.func,
    onFetchLot: PropTypes.func,
    sso: PropTypes.bool,
    location: PropTypes.object
  };

  static defaultProps = {
    RFSManagedBySelectList: []
  };

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(props.location.search);
    this.state = {
      region: convertStringMultiParamsToSelectedOption(
        this.queryParams.inRegions
      ),
      isLoadingRegion: false,
      market: convertStringMultiParamsToSelectedOption(
        this.queryParams.inMarkets
      ),
      isLoadingMarket: false,
      project: convertStringMultiParamsToSelectedOption(
        this.queryParams.inProjects
      ),
      isLoadingProject: false,
      RFSManagedBy: null,
      isLoadingRFSManagedBy: false,
      lot: null,
      isLoadingLot: false,
      createdDateFrom: null,
      createdDateTo: null,
      statusSelectList: defaultStatusSelectList,
      status: this.queryParams.Status
        ? defaultStatusSelectList
          .map(item => ({
            label: item.value,
            value: item.key
          }))
          .filter(x => this.queryParams.Status.includes(x.value))
        : []
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleHideDateRange);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.RegionSelectList && this.state.isLoadingRegion) {
      this.setState({ isLoadingRegion: false });
    }
    if (nextProps.MarketSelectList && this.state.isLoadingMarket) {
      this.setState({ isLoadingMarket: false });
    }
    if (nextProps.ProjectSelectList && this.state.isLoadingProject) {
      this.setState({ isLoadingProject: false });
    }
    if (nextProps.RFSManagedBySelectList && this.state.isLoadingRFSManagedBy) {
      this.setState({ isLoadingRFSManagedBy: false });
    }
    if (nextProps.RequestTypeSelectList && this.state.isLoadingRequestType) {
      this.setState({ isLoadingRequestType: false });
    }

    if (nextProps.LotSelectList && this.state.isLoadingLot) {
      this.setState({ isLoadingLot: false });
    }

    const prevUrlParams = queryString.parse(this.props.location.search);
    const nextUrlParams = queryString.parse(nextProps.location.search);

    if (nextUrlParams.inProjects !== prevUrlParams.inProjects) {
      this.setState({
        project: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inProjects
        )
      });
    }

    if (nextUrlParams.inRegions !== prevUrlParams.inRegions) {
      this.setState({
        region: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inRegions
        )
      });
    }

    if (nextUrlParams.inMarkets !== prevUrlParams.inMarkets) {
      this.setState({
        market: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inMarkets
        )
      });
    }

    if (nextUrlParams.Status !== prevUrlParams.Status) {
      if (nextUrlParams.Status) {
        this.setState({
          status: defaultStatusSelectList
            .map(item => ({
              label: item.value,
              value: item.key
            }))
            .filter(x => nextUrlParams.Status.includes(x.value))
        });
      } else {
        this.setState({ status: [] });
      }
    }

    // if (nextUrlParams.inLot !== prevUrlParams.inLot) {
    //   this.setState({
    //     lot: nextUrlParams.inLot ? queryString.parse(nextUrlParams.inLot) : null
    //   });
    // }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleHideDateRange);
  }

  onFetchRegion = () => {
    this.setState(
      {
        isLoadingRegion: true
      },
      () => {
        this.props.onFetchRegion({
          projectId: this.state.project.map(el => el.value),
          marketId: this.state.market.map(el => el.value),
          lotId: this.state.lot ? this.state.lot.value : ''
        });
      }
    );
  };

  onFetchRequestType = () => {
    this.setState(
      {
        isLoadingRequestType: true
      },
      () => {
        this.props.onFetchRequestType();
      }
    );
  };

  onSelectRegion = value => {
    this.setState(
      {
        region: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSelectRequestType = value => {
    this.setState(
      {
        requestType: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchMarket = () => {
    this.setState(
      {
        isLoadingMarket: true
      },
      () => {
        this.props.onFetchMarket({
          projectId: this.state.project.map(el => el.value),
          regionId: this.state.region.map(el => el.value),
          lotId: this.state.lot ? this.state.lot.value : ''
        });
      }
    );
  };

  onSelectMarket = value => {
    this.setState(
      {
        market: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchProject = () => {
    this.setState(
      {
        isLoadingProject: true
      },
      () => {
        this.props.onFetchProject({
          marketId: this.state.market.map(el => el.value),
          regionId: this.state.region.map(el => el.value),
          lotId: this.state.lot ? this.state.lot.value : ''
        });
      }
    );
  };

  onSelectProject = value => {
    this.setState(
      {
        project: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchLot = () => {
    this.setState(
      {
        isLoadingLot: true
      },
      () => {
        this.props.onFetchLot({
          marketId: this.state.market.map(el => el.value),
          regionId: this.state.region.map(el => el.value),
          projectId: this.state.project.map(el => el.value)
        });
      }
    );
  };

  onSelectLot = value => {
    this.setState(
      {
        lot: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSelectStatus = value => {
    this.setState(
      {
        status: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onFetchRFSManagedBy = () => {
    this.setState(
      {
        isLoadingRFSManagedBy: true
      },
      () => {
        this.props.onFetchRFSManagedBy();
      }
    );
  };

  onSelectRFSManagedBy = value => {
    this.setState(
      {
        RFSManagedBy: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSaveCreationDate = (createdDateFrom, createdDateTo) => {
    this.setState(
      {
        createdDateFrom,
        createdDateTo
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSaveFinalAcceptedDate = (finalAcceptedDateFrom, finalAcceptedDateTo, finalAcceptedType) => {
    this.setState(
      {
        finalAcceptedDateFrom,
        finalAcceptedDateTo,
        finalAcceptedType
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSelectChange = (event, name) => {
    this.setState(
      {
        [name]: event.value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  mapParams = () => {
    const regionIds = [];
    if (this.state.region) {
      this.state.region.map(e => {
        regionIds.push(e.value);
      });
    }
    const marketIds = [];
    if (this.state.market) {
      this.state.market.map(e => {
        marketIds.push(e.value);
      });
    }
    const projectIds = [];
    if (this.state.project) {
      this.state.project.map(e => {
        projectIds.push(e.value);
      });
    }
    const status = [];
    if (this.state.status.length > 0) {
      this.state.status.map(e => {
        status.push(e.value);
      });
    }
    const lots = [];
    if (this.state.lot) {
      lots.push(this.state.lot.value);
    }
    const RFSManagedByIds = [];
    if (this.state.RFSManagedBy) {
      this.state.RFSManagedBy.map(e => {
        RFSManagedByIds.push(e.value);
      });
    }
    const requestTypeIds = [];
    if (this.state.requestType) {
      this.state.requestType.map(e => {
        requestTypeIds.push(e.value);
      });
    }

    let params = {};

    if (regionIds.length) {
      params['RegionIds'] = regionIds.toString();
    }
    if (marketIds.length) {
      params['MarketIds'] = marketIds.toString();
    }
    if (projectIds.length) {
      params['ProjectIds'] = projectIds.toString();
    }

    if (RFSManagedByIds.length) {
      params['ManagedByUserIds'] = RFSManagedByIds.toString();
    }

    if (requestTypeIds.length) {
      params['RequestTypeIds'] = requestTypeIds.toString();
    }

    if (this.state.lot) {
      params['inLot'] = queryString.stringify(pickBy({ ...this.state.lot }));
    }

    if (lots.length) {
      params['LotIds'] = lots.toString();
    }

    status.length
      ? (params['Status'] = status.toString())
      : (params['Status'] = '');

    if (this.state.createdDateFrom) {
      params['CreatedDateFrom'] = this.state.createdDateFrom;
    }
    if (this.state.createdDateTo) {
      params['CreatedDateTo'] = this.state.createdDateTo;
    }

    if (this.state.finalAcceptedType === 'CUSTOM' || this.state.finalAcceptedType === 'ACCEPTED') {
      params['FinalAcceptedDateStatus'] = true;
    }
    else if (this.state.finalAcceptedType === 'NOT_ACCEPTED') {
      params['FinalAcceptedDateStatus'] = false;
    }

    if (this.state.finalAcceptedDateFrom) {
      params['FinalAcceptedDateFrom'] = this.state.finalAcceptedDateFrom;
    }

    if (this.state.finalAcceptedDateTo) {
      params['FinalAcceptedDateTo'] = this.state.finalAcceptedDateTo;
    }

    return params;
  };

  renderUserOption = userList => {
    if (userList.length) {
      if (this.props.sso) {
        let systemUsers = [];
        let builderUsers = [];

        userList.map(item => {
          if (item.extensionValue.sso) {
            systemUsers.push(item);
          } else {
            builderUsers.push(item);
          }
        });

        let options = [
          {
            label: 'System users',
            options: systemUsers
          },
          {
            label: 'Builder users',
            options: builderUsers
          }
        ];

        return options;
      } else {
        return userList;
      }
    } else {
      return [];
    }
  };

  render() {
    return (
      <div className='lot-filter-wrapper box-form-siteone clearfix'>
        <Panel expanded={this.state.panelToggle} style={{border: 'none'}} onToggle={() => {}}>
          <Panel.Heading>
            <Panel.Title>
              <h2 className='col-sm-12' style={{ fontSize: 20, fontWeight: 400 }}>
                Filters
              </h2>
            </Panel.Title>
            <div className='row' style={{ paddingLeft: 15, paddingRight: 15 }}>
              {
                (AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.REGION ||
                 AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.REGION_AND_MARKET) && (
                  <div className='col-sm-3 lot-filter-block'>
                    <label className='col-sm-12 control-label'>
                      <Translate translateKey='region' plurals capitalize />
                    </label>
                    <div className='col-sm-12 control-label'>
                      <Multiselect
                        placeholder='Any'
                        items={this.props.RegionSelectList.map(item => ({
                          label: item.text,
                          value: item.value
                        }))}
                        value={this.state.region}
                        onChange={this.onSelectRegion}
                        onRemote={this.onFetchRegion}
                        isLoading={this.state.isLoadingRegion}
                        ref={ref => {
                          this.project = ref;
                        }}
                      />
                    </div>
                  </div>
                )
              }

              {
                AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.REGION_AND_MARKET && (
                  <div className='col-sm-3 lot-filter-block'>
                    <label className='col-sm-12 control-label'>
                      <Translate translateKey='market' plurals capitalize />
                    </label>
                    <div className='col-sm-12 control-label'>
                      <Multiselect
                        placeholder='Any'
                        isMulti={false}
                        items={this.props.MarketSelectList.map(item => ({
                          label: item.text,
                          value: item.value
                        }))}
                        value={this.state.market}
                        onChange={this.onSelectMarket}
                        onRemote={this.onFetchMarket}
                        isLoading={this.state.isLoadingMarket}
                        ref={ref => {
                          this.project = ref;
                        }}
                      />
                    </div>
                  </div>
                )
              }

              <div className='col-sm-3 lot-filter-block'>
                <label className='col-sm-12 control-label'>
                  <Translate translateKey='project' plurals capitalize />
                </label>
                <div className='col-sm-12 control-label'>
                  <Multiselect
                    placeholder='Any'
                    items={this.props.ProjectSelectList.map(item => ({
                      label: item.text,
                      value: item.value
                    }))}
                    value={this.state.project}
                    onChange={this.onSelectProject}
                    onRemote={this.onFetchProject}
                    isLoading={this.state.isLoadingProject}
                    ref={ref => {
                      this.project = ref;
                    }}
                  />
                </div>
              </div>

              <div className='col-sm-3 lot-filter-block'>
                <label className='col-sm-12 control-label'>Status</label>
                <div className='col-sm-12 control-label'>
                  <Multiselect
                    placeholder='Any'
                    items={AppSettings.RFS_STATUS_VALUE}
                    value={this.state.status}
                    onChange={this.onSelectStatus}
                    labelKey='value'
                    ref={ref => {
                      this.status = ref;
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='row' style={{ paddingLeft: 15, paddingRight: 15 }}>
              <div className='col-sm-3 lot-filter-block'>
                <label className='col-sm-12 control-label'>Lot</label>
                <div className='col-sm-12 control-label'>
                  <Dropdown
                    filter={true}
                    onChange={ref => {
                      this.onSelectChange(ref, 'lot');
                    }}
                    className='filestring-dropdown filter-dropdown'
                    optionLabel='text'
                    placeholder='Any'
                    style={{ width: '100%' }}
                    options={
                      this.props.LotSelectList
                        ? this.props.LotSelectList
                        : [{ ...this.state.lot }]
                    }
                    loading={this.state.isLoadingLot}
                    onRemote={this.onFetchLot}
                    showClear={true}
                    value={this.state.lot}
                  />
                </div>
              </div>

              <div className='col-sm-3 lot-filter-block'>
                <label className='col-sm-12 control-label'>RFS managed by</label>
                <div className='col-sm-12 control-label'>
                  <Multiselect
                    placeholder='Any'
                    items={this.renderUserOption(this.props.RFSManagedBySelectList)}
                    labelKey='text'
                    value={this.state.RFSManagedBy}
                    onChange={this.onSelectRFSManagedBy}
                    onRemote={this.onFetchRFSManagedBy}
                    isLoading={this.state.isLoadingRFSManagedBy}
                    ref={ref => {
                      this.RFSManagedBy = ref;
                    }}
                  />
                </div>
              </div>

              <div className='col-sm-3 lot-filter-block'>
                <label className='col-sm-12 control-label'>Request types</label>
                <div className='col-sm-12 control-label'>
                  <Multiselect
                    placeholder='Any'
                    items={this.props.RequestTypeSelectList.map(item => ({
                      label: item.text,
                      value: item.value
                    }))}
                    value={this.state.requestType}
                    onChange={this.onSelectRequestType}
                    onRemote={this.onFetchRequestType}
                    isLoading={this.state.isLoadingRequestType}
                    ref={ref => {
                      this.requestType = ref;
                    }}
                  />
                </div>
              </div>
              <div className='col-sm-2 lot-filter-block'>
                <label className='col-sm-12 control-label'>Final accepted date</label>
                <AcceptedDateRange className='col-sm-12' onSave={this.onSaveFinalAcceptedDate} />
              </div>
            </div>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body style={{ padding: 0, boxShadow: 'none' }}>
              <div className='row' style={{ paddingLeft: 15, paddingRight: 15 }}>
                <div className='col-sm-2 lot-filter-block'>
                  <label className='col-sm-12 control-label'>Creation date</label>
                  <CustomDateRange className='col-sm-12' onSave={this.onSaveCreationDate} />
                </div>
              </div>
            </Panel.Body>
          </Panel.Collapse>
          <Panel.Footer style={{ backgroundColor: '#fff', paddingTop: 0, borderTop: 0 }}>
            <div style={{ paddingTop: 0, paddingBottom: 0 }}>
              {
                this.state.panelToggle ? (
                  <div>
                    <span
                      onClick={() => { this.setState({ panelToggle: !this.state.panelToggle }); }} style={{ cursor: 'pointer' }}>
                      <i className='fa fa-chevron-circle-up' /> Less
                    </span>
                  </div>
                ) : (
                  <div>
                    <span onClick={() => { this.setState({ panelToggle: !this.state.panelToggle }); }} style={{ cursor: 'pointer' }}>
                      <i className='fa fa-chevron-circle-down' /> More
                    </span>
                  </div>
                )}
            </div>
          </Panel.Footer>
        </Panel>
      </div>
    );
  }
}

export default BuilderPunchListFilter;



// WEBPACK FOOTER //
// ./src/Punch-List/Components/BuilderPunchListFilter.js